import { createAsyncThunk } from '@reduxjs/toolkit';
import { SEND_ABHA_OTP } from '@custom/constant';
import { abhaSendOtpType } from '@custom/Utils/constants/interfaces';

const sendAbhaOtpApi = createAsyncThunk(
    'abha/sendOTP',
    async (payload: abhaSendOtpType, { rejectWithValue }) => {
        try {
            const token = sessionStorage.getItem('token') || localStorage.getItem('token');
            const response = await fetch(SEND_ABHA_OTP, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Failed to send otp');
            }

            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export default sendAbhaOtpApi